import React, { useContext } from 'react';

import Currency from 'components/Currency';

import { FrequentlyBoughtTogetherContext } from '../context';

import './FrequentlyBoughtTogetherTotalPrice.scss';

const FrequentlyBoughtTogetherTotalPrice = () => {

	const { selectedProductsTotalPrice } = useContext(FrequentlyBoughtTogetherContext);
	return (
		<div className="FrequentlyBoughtTogetherTotalPrice">
		Total
			{' '}
			<span className="FrequentlyBoughtTogetherTotalPrice__priceText">
			Price
			</span>
			{' '}
			<Currency price={selectedProductsTotalPrice} superscriptCents />
		</div>
	);

};

export default FrequentlyBoughtTogetherTotalPrice;
